// extracted by mini-css-extract-plugin
export default {"loader":"LoadingMasterData_loader__T6CNc","split":"LoadingMasterData_split__8xQJa"};